import { DB_APPLICATION_STATUS } from '#client/constants/application';

export const ALLOW_REFETCH_STATUS_LIST = [
  DB_APPLICATION_STATUS.NOT_STARTED,
  DB_APPLICATION_STATUS.EXPIRED,
  DB_APPLICATION_STATUS.CLOSED
];
export const NOT_ALLOW_ACCESS_STATUS_LIST = [
  DB_APPLICATION_STATUS.AWAITING_EIN,
  DB_APPLICATION_STATUS.AWAITING_EIN_ORDER_CREATION,
  DB_APPLICATION_STATUS.AWAITING_EIN_ORDER_COMPLETION,
  DB_APPLICATION_STATUS.AWAITING_BANKING_ORDER_COMPLETION,
  DB_APPLICATION_STATUS.SUBMITTED,
  DB_APPLICATION_STATUS.PENDING,
  DB_APPLICATION_STATUS.PENDING_REVIEW,
  DB_APPLICATION_STATUS.AWAITING_DOCUMENTS,
  DB_APPLICATION_STATUS.APPROVED
];
// The required fields which we cannot collect via the Collect Info screen
// The information that we are able to collect via Collect Info screen,
// we will bypass and let the customer provides there. (e.g. ein number, DOB, ssn, passport,…).
// https://counsl.atlassian.net/wiki/spaces/FT/pages/3586000319/Application+Validation
export const BENEFICIAL_OWNER_REQUIRED_VALIDATE_FIELDS = [
  'firstName',
  'lastName',
  'email',
  'phone',
  'country'
];
export const BUSINESS_ENTITY_REQUIRED_VALIDATE_FIELDS = [
  'businessContactFirstName',
  'businessContactLastName',
  'businessContactEmail',
  'businessContactPhone',
  'businessAddressLine1',
  'businessAddressCity',
  'businessAddressCountry',
  'businessAddressState',
  'businessAddressZip',
  'businessEntityName',
  'incorporationState',
  'businessEntityType',
  'applicationDataId',
  'businessEntityUuid',
  'phone',
  'ein',
  'businessPurpose'
];

export const FIELD_KEYS = {
  NAICS_CODE: 'naicsCode',
  SSN: 'ssn',
  EIN: 'ein',
  BUSINESS_ADDRESS_RA: 'businessAddress',
  OPERATIONAL_ADDRESS_RA: 'operationalAddress'
};
